import React, { PropTypes, Component } from "react";

import {
  NitroPanel,
  NitroDivider,
  NitroFormatter,
  NitroText,
  NitroIcon,
  NitroDefinition
} from "nitro-components";

import SummaryHeading from "./SummaryHeading.js";

import styled from "styled-components";

const Container = styled.div`
padding:20px;
display:flex;
align-items:center;
flex-direction:column;

`;

class TablePanel extends Component {
  render() {
    // console.log('SummaryTable', this.props);

    const {
      Header,
      Columns,
      Rows,
      HeaderPostFix,
      Variant,
      HeaderPostFixIcon
    } = this.props;

    let fields = [];

    let headerFields = [];

    for (let i = 0; i < Columns.length; i++) {
      let field = {};
      field.title = Columns[i]["@Display"];
      let propName = Columns[i]["@Name"];
      let description = Rows[0] ? Rows[0][propName] : "";
      field.description = description && Number.isInteger(Number(description))
        ? <NitroFormatter data={description} type="integer" />
        : description;
      fields.push(field);
    }

    if (HeaderPostFix) {
      let field = {};
      field.title = (
        <NitroText
          variant={Variant !== "negative" ? "secondary" : Variant}
          bold
          size={16}
          align="left"
        >
          {Header}{" "}
        </NitroText>
      );
      field.description = (
        <div>
          <NitroIcon variant={Variant} name={HeaderPostFixIcon} right={12} size={18}/>
          <NitroText variant={Variant} bold size={14}>
            {HeaderPostFix}
          </NitroText>
        </div>
      );
      headerFields.push(field);
    } 

    const panelHeader = HeaderPostFix
      ? <NitroDefinition data={headerFields} rowspacing={0} />
      : <NitroText variant="secondary" bold size={16} align="center">
          {Header}{" "}
        </NitroText>;

    return (
      <NitroPanel padding={20}>
        <Container>
          {panelHeader}
          <NitroDivider />
          <NitroDefinition data={fields} rowspacing={12} />
        </Container>
      </NitroPanel>
    );
  }
}

TablePanel.propTypes = {
  Header: PropTypes.string.isRequired,
  Columns: PropTypes.array.isRequired,
  Rows: PropTypes.array.isRequired,
  HeaderPostFix: PropTypes.string,
  Variant: PropTypes.string,
  HeaderPostFixIcon: PropTypes.string
};

export default TablePanel;



// WEBPACK FOOTER //
// ./src/components/factoryComponents/TablePanel.js